import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from "prop-types";
import styled, { css } from 'styled-components';

import ModelViewIcon from '../../icons/ModelView.png';
import PlanViewIcon from '../../icons/PlanView.png';
import PanoViewIcon from '../../icons/PanoView.png';
import { LayoutItem } from './LayoutConstants';
import Hammer from 'hammerjs';

const Container = styled.div.attrs(props => ({
    isOpen:props.isOpen || false,
    width:props.width || 'auto',
    height:props.height || 'auto',
    collapsedWidth:props.collapsedWidth || '24px',
    collapsedHeight:props.collapsedHeight || '24px',
    left:props.left || '8px',
    top:props.top || '8px',
    borderRadius:props.borderRadius || '4px',
    zIndex:props.zIndex || 250,
    animationSpeed:props.animationSpeed || '0.2s'
}))`
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    ${props => !window.isTablet && css`
        width:${props => props.collapsedWidth};
        height:${props => props.collapsedHeight};
    `}
    padding: 4px;
    ${props => window.isTablet && props.isOpen && css`
        padding-top: 40px;
    `}
    ${props => window.isTablet && props.isOpen && css`
        width:${props => props.width};
        height:${props => props.height};
    `}
    ${props => window.isTablet && !props.isOpen && css`
        width:${props => props.collapsedWidth};
        height:${props => props.collapsedHeight};
    `}
    left:${props => props.left};
    top:${props => props.top};
    z-index:${props => props.zIndex};
    position: absolute;
    border:1px solid rgba(255,92,0,0.9);
    border-radius: ${props => props.borderRadius};
    background-color: rgba(255,92,0,0.75);
    box-shadow: 2px 2px 6px 1px rgba(0,0,0,0.2);
    overflow: hidden;
    ${props => !window.isTablet && css`
        transition: all ${props => props.animationSpeed} ease-in-out;
        &:hover {
            width:${props => props.width};
            height:${props => props.height};
            background-color: rgba(255,92,0,0.75);
            border-color: rgba(255,92,0,0.6);
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
        & > div {
            opacity: 0;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
        &:hover > div {
            opacity: 1;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
    `}
    ${props => window.isTablet && props.isOpen && css`
        & > div {
            display: unset;
            opacity: 1;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
    `}
    ${props => window.isTablet && !props.isOpen && css`
        & > div {
            display: none;
            opacity: 0;
            transition: all ${props => props.animationSpeed} ease-in-out;
        }
    `}
`;

const Button = styled.div.attrs(props => ({
    active: props.active || false,
}))`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: center;
    padding: 2px;
    background-color:rgba(255, 255, 255, ${props => props.active?0.8:0.3});
    width: 40px;
    border: 1px solid rgba(0,0,0,0.5);
    border-radius: 3px;
    cursor: ${props => props.active ? 'auto' : 'pointer'};
    transition: all 0.2s ease-in-out;
    &:hover {
        //padding: 1px;
        //border: 2px solid rgba(0,0,0,0.5);
        background-color:rgba(255, 255, 255, ${props => props.active?0.8:0.5});
        transition: all 0.2s ease-in-out;
    }
`;


function LayoutItemSelect(props) {

    const {
        id,
        left, top,
        collapsedWidth, collapsedHeight,
        activeItem, isOpen,
        onLayoutItemClick, onLayoutContainerClick
    } = props;

    const containerRef = useRef();
    const hammerRef = useRef();

    const onLayoutItemClickHandler = useCallback((layoutItem) => {
        if (activeItem === layoutItem)
            return;

        onLayoutItemClick && onLayoutItemClick(id, layoutItem);
    }, [activeItem, onLayoutItemClick]);


    if (window.isTablet) {
        useEffect(() => {

            // hammerRef.current = new Hammer(containerRef.current);
            //
            // hammerRef.current.on("tap", (hammerEvt) => {
            //     onLayoutContainerClick && onLayoutContainerClick();
            // });

            const handler = (evt) => {
                if (isOpen)
                    return;
                onLayoutContainerClick && onLayoutContainerClick();
            };

            containerRef.current.addEventListener("click", handler);

            return () => {
                // hammerRef.current.stop(true);
                // hammerRef.current.destroy();
                // hammerRef.current = null;
                containerRef.current.removeEventListener("click", handler);
            };
        }, [isOpen]);
    }

    const hasButtons = (window.isTablet && isOpen) || (!window.isTablet);

    return (
        <Container
            ref={containerRef}
            left={left}
            top={top}
            isOpen={isOpen}
            collapsedWidth={collapsedWidth}
            collapsedHeight={collapsedHeight}
        >
            {hasButtons &&
                <>
                    <Button
                        active={activeItem === LayoutItem.PANORAMA_VIEWER}
                        onClick={() => onLayoutItemClickHandler(LayoutItem.PANORAMA_VIEWER)}
                    >
                        <img src={PanoViewIcon} width={32} height={32} style={{ pointerEvents:'none' }}/>
                    </Button>
                    <Button
                        active={activeItem === LayoutItem.PLAN_VIEWER}
                        onClick={() => onLayoutItemClickHandler(LayoutItem.PLAN_VIEWER)}
                    >
                        <img src={PlanViewIcon} width={32} height={32} style={{pointerEvents:'none'}} />
                    </Button>
                    <Button
                        active={activeItem === LayoutItem.MODEL_VIEWER}
                        onClick={() => onLayoutItemClickHandler(LayoutItem.MODEL_VIEWER)}
                    >
                        <img src={ModelViewIcon} width={32} height={32} style={{pointerEvents:'none'}} />
                    </Button>
                </>
            }
        </Container>
    );
}


LayoutItemSelect.propTypes = {
    id:PropTypes.string.isRequired,
    left:PropTypes.string,
    top:PropTypes.string,
    collapsedWidth:PropTypes.string,
    collapsedHeight:PropTypes.string,
    isOpen:PropTypes.bool,
    activeItem:PropTypes.string.isRequired,
    onLayoutContainerClick: PropTypes.func.isRequired,
    onLayoutItemClick: PropTypes.func.isRequired,
};


LayoutItemSelect.defaultProps = {
    left:'8px',
    top: '40px',
    collapsedWidth:'24px',
    collapsedHeight:'24px',
    //collapsedWidth:'auto',
    //collapsedHeight:'auto',
    activeItem:'',
    isOpen:false,
    onLayoutContainerClick: () => {}
};


export default LayoutItemSelect;